import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {HeaderService} from './header.service';

@Injectable()
export class FirmGroupService extends HeaderService {

    createFirmGroup(AutomatGroup: any): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'automat-group/',
            JSON.stringify(AutomatGroup),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    deleteGroup(_id: any): Observable<any> {
        return this.http.delete(environment.apiBaseUrl + 'automat-group/' + _id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    updateGroup(Group: any, _id: String): Observable<any> {
        return this.http.put(environment.apiBaseUrl + 'automat-group/' + _id,
            JSON.stringify(Group),
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

    getGroupById(id: String): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'automat-group/' + id,
            this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/firm-group.service.ts